export type MetricFormatType =
  | "currency"
  | "percent"
  | "percent_whole"
  | "integer";

/** Moneda con decimales fijos (p. ej. $749.95, no $750). */
export function formatCurrencyExact(
  value: number,
  currencyCode: string,
  locale: string,
  fractionDigits = 2
): string {
  if (!Number.isFinite(value)) return "—";
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(value);
}

export function formatChartNumber(
  formatType: MetricFormatType,
  value: number,
  currencyCode: string,
  locale: string
): string {
  if (!Number.isFinite(value)) return "—";
  switch (formatType) {
    case "currency":
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currencyCode,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(value);
    case "percent":
      return `${value.toLocaleString(locale, { maximumFractionDigits: 1 })}%`;
    case "percent_whole":
      return `${Math.round(value).toLocaleString(locale, {
        maximumFractionDigits: 0,
      })}%`;
    case "integer":
    default:
      return Math.round(value).toLocaleString(locale);
  }
}

export function formatKpiHeadline(
  formatType: MetricFormatType,
  value: number,
  currencyCode: string,
  locale: string
): string {
  return formatChartNumber(formatType, value, currencyCode, locale);
}

/** Eje X con etiquetas ISO tipo referencia (YYYY-MM-DD). */
export function formatAxisDateIso(iso: string): string {
  if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) return iso;
  return String(iso).slice(0, 10);
}

export function formatYAxisTick(
  formatType: MetricFormatType,
  value: number,
  currencyCode: string,
  locale: string
): string {
  if (formatType === "currency") {
    const n = new Intl.NumberFormat(locale, {
      maximumFractionDigits: value >= 100 ? 0 : 2,
    }).format(value);
    return `${currencyCode} ${n}`;
  }
  return formatChartNumber(formatType, value, currencyCode, locale);
}
